import { render, staticRenderFns } from "./ViewerCurrentMisc.vue?vue&type=template&id=e127ca20"
import script from "./ViewerCurrentMisc.vue?vue&type=script&lang=js"
export * from "./ViewerCurrentMisc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports